import React from 'react'
import { Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { localizeCurrency, sumTotal } from '../utils'
import { GridElement } from '../GridElement'
import { GridTable } from '../GridTable'

interface TableTotalProps {
  sums: string[]
}

export const TableTotal: React.FC<TableTotalProps> = ({ sums }) => {
  const { t } = useTranslation(['payments'])

  return (
    <GridTable className="mt-2">
      <GridElement columns={2}>
        <Span bold>{t('payments:sumTotal')}</Span>
      </GridElement>

      <GridElement columns={2} align="right">
        <Span bold>
          {localizeCurrency(sumTotal(sums.map((s) => Number(s))))}
        </Span>
      </GridElement>
    </GridTable>
  )
}
